export const fetchData = async (endpoint) => {
    let response = await fetch(`${endpoint}/webflow/places`);
    if (!response.ok) {
        throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }
    const data = response.json();
    return data;
}